import img1 from '../../assets/2017/1.webp';
import img2 from '../../assets/2017/2.webp';
import img3 from '../../assets/2017/3.webp';
import img4 from '../../assets/2017/4.webp';
import img5 from '../../assets/2017/5.webp';
import img6 from '../../assets/2017/6.webp';
import img7 from '../../assets/2017/7.webp';
import img8 from '../../assets/2017/8.webp';
import img9 from '../../assets/2017/9.webp';
import img10 from '../../assets/2017/10.webp';
import img11 from '../../assets/2017/11.webp';
import img12 from '../../assets/2017/12.webp';
import img13 from '../../assets/2017/13.webp';
import img14 from '../../assets/2017/14.webp';

const img2017 = {
  img1: img1,
  img2: img2,
  img3: img3,
  img4: img4,
  img5: img5,
  img6: img6,
  img7: img7,
  img8: img8,
  img9: img9,
  img10: img10,
  img11: img11,
  img12: img12,
  img13: img13,
  img14: img14,
};

export default img2017;
